import React, { useState } from 'react'
import ConfirmationPopUp from '../../../../common/ConfirmationPopUp'
import { useTranslation } from 'react-i18next'
const UserTable = ({
	userList,
	columns,
	initiateUpdateUserStatus,
	handleUpdateUser,
	setAlertMessage,
	setUpdateSuccess,
}) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])

	const [displayPopup, setDisplayPopUp] = useState(false)
	const [user, setUser] = useState(null)

	const updateUserStatus = (evnt, userData) => {
		evnt.preventDefault()
		evnt.stopPropagation()

		setUser(userData)
		setDisplayPopUp(true)
	}

	const handleStatusChange = () => {
		setAlertMessage('')
		setUpdateSuccess(false)
		initiateUpdateUserStatus(user)
	}

	const handleonChange = () => { }

	const goToUpdateUserPage = (userId) => {
		handleUpdateUser(userId, true)
	}

	return (
		<>
			<div className='user-list-table-wrapper'>
				<div className='common-list-table-scroll'>
					<table className='common-list-table' id='userList'>
						<thead>
							<tr className='table-header'>
								{columns && columns.length > 0 && columns.map((column, columnIndex) => (
									<th className='header-cell' key={columnIndex}>
										{t(column)}
									</th>
								))}
								<th className='header-cell'>{t('COMMON.STATUS')}</th>
							</tr>
						</thead>

						<tbody className='table-body'>
							{userList && userList.length !== 0 ? (
								userList.map((user, userIndex) => (
									<tr
										key={userIndex}
										className={`body-row ${userIndex % 2 === 0 ? 'even' : ''} clickableRow`}
										onClick={() => goToUpdateUserPage(user.userId)}
									>
										<td className='body-cells'>{user.firstName} {user.lastName}</td>
										<td className='body-cells'>{user.userId}</td>
										<td className='body-cells'>{user.lastLoginTime}</td>
										<td className='body-cells'>
											<div className='switch'>
												<label className='switch-label mt-0'>
													<input
														type='checkbox'
														id='status'
														checked={user.status}
														onChange={handleonChange}
													/>
													<span
														className='switch-btn round-btn'
														aria-label='status checkbox'
														onClick={(evnt) => updateUserStatus(evnt, user)}
													></span>
												</label>
											</div>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={(columns?.length || 0) + 1}>
										<label className='no-data-avilable'>{t('PERMANENT_BOOKING.NO_DATA')}</label>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
				</div>
			


			{displayPopup ? (
				<ConfirmationPopUp
					displayPopUp
					setDisplayPopUp={setDisplayPopUp}
					headerText={`${user.status ? t('UM.DEACTIVATING') : t('UM.ACTIVATING')} ${user.firstName} ${user.lastName} `}
					message={`${t('UM.ACT_DEACT_DIALOG', {
						status: user.status ? t('UM.DEACTIVATE') : t('UM.ACTIVATE'),
						name: `${user.firstName} ${user.lastName}`,
					})}`}
					primaryBtnLbl={
						user.status ? t('UM.DEACTIVATE_BUTTON') : t('UM.ACTIVATE_BUTTON')
					}
					secondaryBtnLbl={t('COMMON.CANCEL')}
					acceptFn={handleStatusChange}
				/>
			) : (
				<></>
			)}
		</>
	)
}

export default UserTable
